import React, { useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';
import './TalkAttachmentModals.css';

const TalkAttachmentPdfViewerModal = ({ upload, onClose }) => {
    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') onClose(); };
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, [onClose]);

    if (!upload) return null;

    const handleBackdropClick = (e) => { if (e.target === e.currentTarget) onClose(); };

    return (
        <div
            className="talk-attach-overlay"
            onClick={handleBackdropClick}
            role="dialog"
            aria-modal="true"
            aria-label={`Viewing ${upload.name}`}
        >
            <div className="talk-attach-modal">
                <div className="talk-attach-header">
                    <span className="talk-attach-title" title={upload.name}>{upload.name}</span>
                    <button className="talk-attach-close-btn" onClick={onClose} aria-label="Close PDF viewer">
                        <FaTimes />
                    </button>
                </div>
                <div className="talk-attach-body">
                    <iframe src={upload.url} className="talk-attach-iframe" title={upload.name} />
                </div>
            </div>
        </div>
    );
};

export default TalkAttachmentPdfViewerModal;
